import React from 'react';
import DataTable from '../DataTable/DataTable';
import Tabs from '../Tabs/Tabs';

export default class ReservationSegmentCheckInPayments extends React.Component {
  constructor(props){
    super(props);

  };

  render(){
    return(
      <div className="panel panel-default">
        <div className="panel-body container">
          <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20 }}>{I18n.t('folios')} </h5>
          <DataTable endpoint={this.props.reservation_segment_check_in_folios_data_table} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> 
        </div>
      </div>
    );
  };




};